import * as types from 'modules/notifications/actionTypes';
import { uniq } from 'utils/ObjectUtils';

import { createReducer } from 'utils/ReduxUtils';

/** @typedef {import('../../../types.js').Notification} Notification */

/** @type {Array<Notification>} State */
const initialState = [];

/**
 * @param {State} state
 * @param {import('../../../types.js').AddNotificationAction} action
 * @returns {State} The updated state
 */
const add = (state, { payload }) => uniq([...(payload.notifications?.map(({ id }) => id) ?? []), ...state]).slice(0, 5);

/**
 * @param {State} state
 * @param {import('../../../types.js').DeleteNotificationActionSuccess} action
 * @returns {State} The updated state
 */
const deleteOne = (state, { payload }) => state.filter(id => id !== payload);

/**
 * @param {State} _
 * @param {import('../../../types.js').FetchNotificationsActionSuccess} action
 * @returns {State} The updated state
 */
const set = (_, { payload }) => payload.notifications?.map(({ id }) => id) ?? [];

/**
 * @param {State} state
 * @param {import('../../../types.js').FetchNotificationsActionSuccess} action
 * @returns {State} The updated state
 */
const setFromDashboard = (state, { payload, meta }) => {
  if (!meta.params.last) {
    return payload.notifications?.slice(0, 5).map(({ id }) => id) ?? [];
  }

  return state;
};

export default createReducer(initialState, {
  [types.ADD]: add,
  [types.DELETE_NOTIFICATION_SUCCESS]: deleteOne,
  [types.FETCH_DROPDOWN_NOTIFICATIONS_SUCCESS]: set,
  [types.FETCH_NOTIFICATIONS_DASHBOARD_SUCCESS]: setFromDashboard,
});
